.container {
  padding-inline: 16px;
}
